<template>
  <el-dialog
    title="新增扫码商品"
    :visible.sync="visible"
    width="960px"
    @closed="handleClosed">
    <div
      v-if="list.length"
      style="height:500px;overflow:auto">
      <div class="card-list">
        <content-card
          v-for="(item,index) in list"
          :key="index"
          :info="item"
          showCheckbox
          @click.native="seclectCard(item,index)">
          <div
            class="operation"
            @click.stop>
            <el-input-number
              v-model="item.points"
              :min="1"
              style="margin-right: 10px"
              :controls="false"
              :disabled="!item.checked"></el-input-number>
            <el-switch
              v-model="item.isopen"
              :active-value="1"
              :inactive-value="0"
              active-text=""
              inactive-text=""
              :disabled="!item.checked">
            </el-switch>
          </div>
        </content-card>
      </div>
    </div>
    <empty v-else />
    <div slot="footer">
      <el-button
        v-if="list.length"
        type="primary"
        @click="add">确 定</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ContentCard from '../../content-card.vue'
export default {
  name: 'AddSacnProductModal',
  components: { ContentCard },
  props: {
    vendorId: [Number, String],
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
    },
    seclectCard(item) {
      item.checked = !item.checked
    },
    add() {
      const checkList = this.list.filter(i => i.checked)
      if (!checkList.length) {
        this.$message.error('请至少选择一个商品')
        return
      }
      this.loading = true
      this.$store.dispatch('integral/addscanccodepointsrules', {
        payload: {
          rules: checkList,
          vendorId: this.vendorId
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('integral/getnoscanccodepointsruleproductnames', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          vendorId: this.vendorId
        },
        success: res => {
          this.loading = false
          this.list = res.data.data.map(item => {
            item.isopen = 1
            item.points = 1
            item.checked = false
            item.ciqcaPrstypeid = item.prstypeid
            item.ciqcaPrstypename = item.productname
            item.title = item.productname
            item.image = item.productimage
            return item
          })
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.card-list {
  display: flex;
  flex-wrap: wrap;

  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
</style>
